<template>
    <b-modal
        title-tag="h2"
        title="Email Letter"
        lazy
        :visible="isOpen"
        no-enforce-focus
    >
        <form>
            <b-form-group label-cols="2" label="To:" label-for="to">
                <recipient-email
                    v-model="recipient"
                    multiple
                    placeholder="Client or Contact Email (required)"
                    @input="values => handleRecipientChangeAlt(values, true)"
                    :client="clientDetails"
                    :key="recipientComponentKey"
                    :filterData="false"
                />
            </b-form-group>

            <b-form-group label-cols="2" label="Subject:" label-for="subject">
                <b-form-input
                    v-model="subject"
                    :placeholder="
                        isLoadingEmailDefaultLetter
                            ? 'Loading...'
                            : 'Subject (optional)'
                    "
                />
            </b-form-group>

            <b-form-group label-cols="2" label="Message:" label-for="message">
                <tinymce :init="tinymceConfig" v-model="message" />
            </b-form-group>
        </form>

        <template v-slot:modal-footer>
            <loader v-if="isSending" class="m-0" />

            <b-button
                class="mr-auto"
                variant="secondary"
                @click="close"
                v-if="!isSending"
            >
                Cancel
            </b-button>

            <b-button v-if="!isSending" variant="primary" @click="send">
                Send
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import ClientDocumentService from "@/services/client-documents";
import Loader from "@/module/commons/loader";
import tinymce from "@tinymce/tinymce-vue";
import tinymceHelper from "@/module/commons/helper-tinymce"; // helper
import recipientEmail from "@/components/commons/recipients-email";
import EmailMixins from "@/mixins/email";

export default {
    components: {
        Loader,
        tinymce,
        recipientEmail
    },
    mixins: [EmailMixins],
    data() {
        return {
            isOpen: false,
            letterId: null,
            recipient: [],
            subject: "",
            message: "",
            isLoading: true,
            isSending: false,
            isLoadingEmailDefaultLetter: true,
            clientDetails: null,
            recipientComponentKey: 0,
            emailDefaultLetter: {
                body: null,
                subject: null
            },
            tinymceConfig: {
                ...tinymceHelper.core, // use spread operator to inject all vetter-related configs
                toolbar: false,
                plugins: tinymceHelper.plugins
            }
        };
    },
    methods: {
        async open(record) {
            this.isOpen = true;
            this.letterId = record.id;
            await this.fetchSetEmailDefaultLetter(record);
            this.setDefaultRecipient();
        },
        close() {
            this.isOpen = false;
        },
        setDefaultRecipient() {
            let client = this.$store.state.client.client_details;

            // set if recipient has email
            if (client && client.email && client.email !== "") {
                this.clientDetails = this.$store.state.client.client_details;
                this.recipientComponentKey++; // force re-render
            }
        },
        async send() {
            const firstRecipient = this.recipient[0];

            if (!firstRecipient || this.message === "") {
                return;
            }

            this.isSending = true;

            const { firstname, lastname } = firstRecipient;

            // -- VET-433, recipient to_id have 3 categories, [business] = business/company, [actor] = contact, [a] = client
            const successSent = await ClientDocumentService.sendEmail({
                letterId: this.letterId,
                to: this.recipient.map(r => r.to_id),
                firstname,
                lastname,
                subject: this.subject,
                message: this.message,
                timestamp: this._now().toFormat("X")
            });

            this.isSending = false;

            if (successSent) {
                this.close();
                this._message("Letter emailed");
            } else {
                this._message("Error: Unable to send email", "danger");
            }
        },
        async fetchSetEmailDefaultLetter(record) {
            this.isLoadingEmailDefaultLetter = true;

            const res = await ClientDocumentService.getEmailTemplate({
                clientId: this.$store.state.client.client_id,
                businessId: this._setting.business.id,
                patientId: record.patient ? [record.patient.id] : [],
                skipVariableReplacement: true
            });

            this.emailDefaultLetter = {
                body: res.message,
                subject: res.subject
            };

            this.isLoadingEmailDefaultLetter = false;
            this.subject = res.subject;
            this.message = this.setNamesElement(
                this.emailDefaultLetter.body,
                false
            );
        }
    }
};
</script>
